import { useCallback, useMemo, useState } from 'react';
import constate from '../../common/lib/constate';

function useClips() {
  const [selectedClips, setSelectedClips] = useState({});
  const [videosWithClips, setVideosWithClips] = useState({});
  const [foldersWithClips, setFoldersWithClips] = useState({});

  const toggleSelectedClip = useCallback(
    (folderId, videoId, clip) => {
      if (selectedClips[clip.id]) {
        // Delete selected clip
        const selectedClipsData = { ...selectedClips };
        delete selectedClipsData[clip.id];
        setSelectedClips({ ...selectedClipsData });

        // Delete clip from videos array
        if (videosWithClips[videoId] > 1) {
          setVideosWithClips({ ...videosWithClips, [videoId]: videosWithClips[videoId] - 1 });
        } else {
          const selectedVideosData = { ...videosWithClips };
          delete selectedVideosData[videoId];
          setVideosWithClips({ ...selectedVideosData });
        }
        // Delete clip from folders array
        if (foldersWithClips[folderId] > 1) {
          setFoldersWithClips({ ...foldersWithClips, [folderId]: foldersWithClips[folderId] - 1 });
        } else {
          const selectedFoldersData = { ...foldersWithClips };
          delete selectedFoldersData[folderId];
          setFoldersWithClips({ ...selectedFoldersData });
        }
        return;
      }

      setSelectedClips({ ...selectedClips, [clip.id]: { ...clip, selected: true } });
      setVideosWithClips({
        ...videosWithClips,
        [videoId]: videosWithClips[videoId] ? videosWithClips[videoId] + 1 : 1,
      });
      setFoldersWithClips({
        ...foldersWithClips,
        [folderId]: foldersWithClips[folderId] ? foldersWithClips[folderId] + 1 : 1,
      });
    },
    [selectedClips, foldersWithClips, videosWithClips]
  );

  const toggleUnselectClips = useCallback(() => {
    setVideosWithClips({});
    setFoldersWithClips({});
    return setSelectedClips({});
  }, []);

  return useMemo(
    () => ({
      selectedClips,
      videosWithClips,
      foldersWithClips,
      toggleSelectedClip,
      toggleUnselectClips,
    }),
    [selectedClips, videosWithClips, foldersWithClips, toggleSelectedClip, toggleUnselectClips]
  );
}

export const useClipsContext = constate(useClips);

const ClipsContext = {
  Provider: useClipsContext.Provider,
};

export default ClipsContext;
